/**
 * Divide un nome di persona in testa e coda per il taglio "dall'inizio".
 *
 * Con nomi lunghi che iniziano tutti uguali ("OPERATORE AXORA GROUP OP15 ANNA",
 * "OPERATORE AXORA GROUP OP16 MARIA") il taglio alla fine li rende identici.
 * La coda (ultime 2 parole) resta sempre visibile, si accorcia solo la testa.
 * Con 2 parole o meno la testa e' vuota e il nome resta intero nella coda.
 */
export interface PersonNameParts {
  head: string;
  tail: string;
}

export function splitPersonName(name: string | null | undefined, tailWords = 2): PersonNameParts {
  const clean = (name ?? '').trim().replace(/\s+/g, ' ');
  if (!clean) return { head: '', tail: '' };
  const words = clean.split(' ');
  const n = Math.max(1, tailWords);
  if (words.length <= n) return { head: '', tail: clean };
  return { head: words.slice(0, -n).join(' '), tail: words.slice(-n).join(' ') };
}
